// src/components/register/RegistrationWizard/Steps/PersonalDetailsStep.js
import React, { useState, useEffect } from "react";
import { useRegistration } from "../../../../context/RegistrationContext";
import { toast } from "react-toastify";
import OpguruLogo from "../../../../assets/opgurulogo.png";
import { TailSpin } from "react-loader-spinner";
import InputField from "../../../Usables/InputField";
import Dropdown from "../../../Usables/Dropdown/Dropdown";
import Gender from "../../../options/Gender.js";

const PersonalDetailsStep = () => {
  const {
    name,
    firstname,
    lastname,
    gender,
    country,
    city,
    homestate,
    pin,
    setField,
    setMultipleFields,
    nextStep,
    prevStep,
    validateStep,
    formErrors,
  } = useRegistration();

  const [loading, setLoading] = useState(false);

  // Auto-split the full name into first and last name on component mount
  useEffect(() => {
    if (name && (!firstname || !lastname)) {
      const nameParts = name.trim().split(/\s+/);
      if (nameParts.length > 0) {
        const firstName = nameParts[0];
        const lastName = nameParts.length > 1 ? nameParts.slice(1).join(' ') : '';
        
        setMultipleFields({
          firstname: firstName,
          lastname: lastName
        });
      }
    }
    console.log("Personal details updated:", { firstname, lastname, gender, country, city });
  }, [name, firstname, lastname, setMultipleFields]);

  const handleChange = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setField(name, value);
  };

  const handleGenderChange = (selectedOption) => {
    setField('gender', selectedOption.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log("Validation result:", validateStep(4));
    console.log("Form errors:", formErrors);

    if (!validateStep(4)) {
        toast.error("Please fill all the required fields", {
            position: "top-center",
        });
        return;
    }

    console.log("Validation passed, moving to next step");
    nextStep();
};

  return (
    <div className="step-container">
      <div className="auth-header">
        <div className="auth-title">Personal Details</div>
        <div className="auth-logo">
          <img src={OpguruLogo} alt="OpGuru Logo" />
        </div>
      </div>

      <div className="welcome-message">
        Please provide your personal information
      </div>

      <form onSubmit={handleSubmit} className="registration-form">
        <div className="name-fields-row">
          <div className="input-group half-width">
            <InputField
              type="text"
              value={firstname}
              placeholder="First Name"
              name="firstname"
              onChange={handleChange}
              error={formErrors.firstname}
            />
          </div>
          
          <div className="input-group half-width">
            <InputField
              type="text"
              value={lastname}
              placeholder="Last Name"
              name="lastname"
              onChange={handleChange}
              error={formErrors.lastname}
            />
          </div>
        </div>

        <div className="input-group">
          <Dropdown
            options={Gender}
            placeHolder="Select Gender"
            onChange={handleGenderChange}
            selectedValue={gender !== "" ? { value: gender, label: Gender[parseInt(gender)-1].label } : null}
            error={formErrors.gender}
          />
        </div>

        <div className="input-group">
          <InputField
            type="text"
            value={country}
            placeholder="Country"
            name="country"
            onChange={handleChange}
            error={formErrors.country}
          />
        </div>

        <div className="location-fields-row">
          <div className="input-group half-width">
            <InputField
              type="text"
              value={city}
              placeholder="City"
              name="city"
              onChange={handleChange}
              error={formErrors.city}
            />
          </div>
          
          <div className="input-group half-width">
            <InputField
              type="text"
              value={homestate}
              placeholder="State"
              name="homestate"
              onChange={handleChange}
              error={formErrors.homestate}
            />
          </div>
        </div>

        <div className="input-group">
          <InputField
            type="text"
            value={pin}
            placeholder="PIN Code"
            name="pin"
            onChange={handleChange}
            error={formErrors.pin}
          />
        </div>

        <div className="button-group">
          <button
            type="button"
            className="secondary-button"
            onClick={prevStep}
          >
            Back
          </button>
          
          <button
            type="submit"
            className="primary-button"
            disabled={loading}
          >
            {loading ? (
              <TailSpin
                visible={true}
                height="24"
                width="24"
                color="#ffffff"
                ariaLabel="tail-spin-loading"
                radius="1"
              />
            ) : (
              "Next"
            )}
          </button>
        </div>
      </form>
    </div>
  );
};

export default PersonalDetailsStep;